var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control",attrs:{"type":_vm.foreign ? 'text' : 'tel',"inputmode":"tel","autocomplete":"off","maxlength":_vm.foreign ? 20 : null},domProps:{"value":_vm.display},on:{"input":_vm.onInput,"paste":_vm.onPaste,"focus":_vm.keepCaretAfterPrefix,"click":_vm.keepCaretAfterPrefix,"keydown":_vm.onKeydown}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c6a6dd6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormFields/PhoneInput.vue
// module id = 624
// module chunks = 30